import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from "vant" // 引入英文语言包
import zh from './locales/zh-CN'
import en from './locales/en'
import enUS from "vant/es/locale/lang/en-US"
import zhCN from "vant/es/locale/lang/zh-CN"


Vue.use(VueI18n)

const savedLang = localStorage.getItem('lang') || 'zh-CN'
console.log('savedLang :>> ', savedLang);
Locale.use(savedLang === "en" ? "en-US" : "zh-CN", savedLang === "en" ? enUS : zhCN)

export default new VueI18n({
  locale: savedLang || 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zh,
    'en': en
  }
})


